<script>
import { mapActions, mapState, mapGetters } from "vuex";

import Modal from "@/components/_Shared/Modal/Index";
import Title from "@/components/_Shared/Title";
import Tip from "@/components/_base/Tip";

import CancellationType from "./CancellationType";
import CancellationData from "./CancellationData";
import CancellationRefund from "./CancellationRefund";
import CancellationReschedule from "./CancellationReschedule";
import Success from "./Success";
import Error from "./Error";

export default {
  components: {
    Modal,
    Title,
    Tip,
    CancellationType,
    CancellationData,
    CancellationRefund,
    CancellationReschedule,
    Success,
    Error
  },

  props: {
    order: {
      type: Object,
      required: true
    },

    type: {
      type: String,
      required: true
    }
  },

  methods: {
    ...mapActions("orderCancellation", [
      "reset",
      "initializeStore",
      "previousStep",
      "nextStep",
      "setCancellationAction"
    ]),

    headerText() {
      return {
        cancellation: "Solicitar cancelamento",
        absence: "Comunicar falta de profissional",
        rescheduling: "Solicitar reagendamento"
      }[this.type];
    }
  },

  computed: {
    ...mapState("orderCancellation", [
      "step",
      "cancellationReason",
      "cancellationAction",
      "ticketCreated",
      "ticketCreationError"
    ]),
    ...mapGetters("orderCancellation", [
      "isPaidWithBoleto",
      "canFinishCancellation",
      "allowToSendTicket",
      "shouldRequestRefundInfo",
      "shouldRequestRescheduleInfo",
      "isCancellationPossible"
    ]),

    buttonText: function() {
      const {
        ticketCreated,
        ticketCreationError,
        canFinishCancellation,
        cancellationAction,
        isCancellationPossible
      } = this;

      if (ticketCreated || ticketCreationError) {
        return "fechar";
      }

      if (canFinishCancellation && !isCancellationPossible) {
        return "confirmar cancelamento";
      }

      if (canFinishCancellation && cancellationAction === "credit") {
        return "cancelar limpeza e deixar como crédito";
      }

      if (
        !canFinishCancellation &&
        ["cancel", "reschedule"].includes(cancellationAction)
      ) {
        return "avançar";
      }

      if (canFinishCancellation && cancellationAction === "cancel") {
        return "solicitar reembolso";
      }

      if (canFinishCancellation && cancellationAction === "reschedule") {
        return "solicitar reagendamento";
      }

      return "confirmar";
    }
  },

  async mounted() {
    await this.reset();

    await this.initializeStore({
      order: this.order,
      reason: this.type,
      exit: () => this.$emit("close")
    });
  }
};
</script>

<template>
  <Modal>
    <template slot="header">
      <Title :title="headerText()" />
    </template>

    <template slot="body">
      <Success v-if="ticketCreated" />

      <Error v-else-if="ticketCreationError" />

      <CancellationType v-else-if="step === 0" />

      <CancellationData v-else-if="step === 1" />

      <CancellationRefund v-else-if="shouldRequestRefundInfo" />

      <CancellationReschedule v-else-if="shouldRequestRescheduleInfo" />
    </template>

    <template slot="footer">
      <Tip v-if="!cancellationAction">
        Selecione uma das opções acima ou clique no botão abaixo para voltar
      </Tip>

      <button
        class="btn bg-purple"
        v-if="(step === 0 && ticketCreated) || step > 0"
        :class="{ 'btn-disabled': !ticketCreated && !allowToSendTicket }"
        @click="nextStep"
      >
        <span>
          {{ buttonText }}
        </span>
      </button>

      <button class="btn bg-outlined" v-if="!ticketCreated && !ticketCreationError" @click="previousStep">
        <span>
          {{ step != 0 ? 'voltar' : 'não quero cancelar' }}
        </span>
      </button>
    </template>
  </Modal>
</template>

<style scoped>
.bg-outlined {
  padding: 8px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Components/Actions/Cancellation/Index.vue